import React from 'react'

import { Button, Modal, ModalInjectedProps } from '@sketch/components'

import { useDeleteScimPersonalAccessToken } from '../../operations'

import { useToast } from '@sketch/toasts'

import { ScimPersonalAccessTokenFragment } from '@sketch/gql-types'

interface DeleteScimPersonalAccessTokenConfirmationModalProps
  extends ModalInjectedProps {
  token: ScimPersonalAccessTokenFragment
  onCompleted?: () => void
}

const DeleteScimPersonalAccessTokenConfirmationModal: React.FC<
  DeleteScimPersonalAccessTokenConfirmationModalProps
> = props => {
  const { token, hideModal } = props
  const { showToast } = useToast()
  const truncatedDescription =
    token.description.length < 30
      ? token.description
      : `${token.description.slice(0, 29)}...`

  const [deleteToken, { loading }] = useDeleteScimPersonalAccessToken({
    onCompleted: () => {
      hideModal()
      const message = `“${truncatedDescription}” successfully deleted`
      showToast(message)
    },
  })

  const handleConfirmDeleteClick = async () => {
    await deleteToken({ identifier: token.identifier })
  }

  return (
    <Modal title="Delete this Token?" onCancel={hideModal}>
      <Modal.Body>
        Deleting “{token.description}” will instantly revoke access from all
        applications that use it.
        <br />
        <br />
        You can always create more personal access tokens.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirmDeleteClick}
          loading={loading}
          variant="negative"
        >
          Delete Token
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteScimPersonalAccessTokenConfirmationModal
